import * as React from 'react';

import type { HeadProps, PageProps } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

import { CtaBlock } from 'stile-shared/src/components/2020/blocks/CtaBlock';

import { PageLayout } from 'templates/2024/PageLayout';
import { SEO } from 'templates/2024/SEO';

import { ResourceAccessBlock } from 'components/common/ResourceAccessBlock';

export function Head(props: HeadProps) {
  return (
    <SEO
      title="EdTech Security and Privacy Checklist"
      description="Questions to ask an EdTech before entrusting your students' data."
      slug={props.location.pathname}
    />
  );
}

function SecurityPrivacyPage(props: PageProps) {
  return (
    <PageLayout {...props}>
      <ResourceAccessBlock
        title="EdTech Security and Privacy Checklist"
        subtitle="Questions to ask an EdTech before entrusting your students' data."
        id="ICT_INFO"
        redirectUrl="https://stileapp.com/go/security-guide"
        image={
          <StaticImage
            src="../../../../stile-shared/assets/images/resources/ed_tech_resource.png"
            alt=""
          />
        }
      >
        <p>
          We’ve developed a best practice guide on how to assess the security and privacy of your
          education technology provider. Created with rigorous security and privacy practices as its
          core, it covers everything from disclosure policies, penetration tests, bug bounties, data
          ownership, and more.
        </p>
        <p>Follow this checklist guide to ensure your students’ data is safe.</p>
      </ResourceAccessBlock>

      <CtaBlock />
    </PageLayout>
  );
}

export default SecurityPrivacyPage;
